module.exports = __webpack_public_path__ + "img/chineseMedicine.45527021.svg";